const serviceCurrentLocationMixin = {
  computed: {
    currentCountry() {
      return this.$store.state.service.currentLocation.country
    },
    currentBase() {
      return this.$store.state.service.currentLocation.base
    },
    currentLocationQueryParams() {
      return {
        ...this.currentBase && { current_base_id: this.currentBase.id },
        ...(!this.currentBase && this.currentCountry) && { current_country_id: this.currentCountry.id }
      }
    }
  },
  watch: {
    currentBase: function () {
      this.onCurrentLocationUpdate()
    },
    currentCountry: function () {
      this.onCurrentLocationUpdate()
    }
  },
  methods: {
    onCurrentLocationUpdate() {
      // on location change
    }
  }
}

export default serviceCurrentLocationMixin
